import React, { useState, useEffect } from "react";
import config from "../../config";

// components
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from "moment";
import 'moment/locale/es-mx';
import { Dialog, TextField, CircularProgress } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Modal from "../modals/Modal";
import Autocomplete from '@material-ui/lab/Autocomplete';
import Switch from "./component/switch";

// styles
import useStyles from "./styles";
import "react-big-calendar/lib/css/react-big-calendar.css";

const formats = {
  dayFormat: (date, culture, loca) => loca.format(date, "dddd D"),
  weekdayFormat: (date, culture, loca) => loca.format(date, "dddd"),
  agendaDateFormat: (date, culture, loca) =>
    loca.format(date, "dddd D MMMM YYYY")
};

export default function Sauna() {
  const expressions = {
    usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
    nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
    password: /^.{4,12}$/, // 4 a 12 digitos.
    email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
    numbers: /^[0-9]*$/, // 7 a 14 numeros.
    texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
    textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
  }

  const classes = useStyles();
  const localizer2 = momentLocalizer(moment);

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [isLoading, setIsLoading] = useState(true);
  const [allSaunaSchedule, setAllSaunaSchedule] = useState([]);
  const [events, setEvents] = useState([]);
  const [partner, setPartner] = useState({ name: '', gender: '', id: '', valid: null, isPartnerOfGym: 0 });
  const [eventModified, setEventModified] = useState({ id: '', userId: '', title: '', startDate: '', start: '', endDate: '', end: '', gender: '', isPartnerOfGym: 0 });
  const [startTime, setStartTime] = useState('00:00');
  const [endTime, setEndTime] = useState('00:00');
  const [newEventDate, setNewEventDate] = useState('');
  const [dateSlot, setDateSlot] = useState('');
  const [openSlot, setOpenSlot] = useState(false);
  const [openEvent, setOpenEvent] = useState(false);
  const [calendarKey, setCalendarKey] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isSelectedWomen, setIsSelectedWomen] = useState(false);
  const [isSelectedMen, setIsSelectedMen] = useState(false);
  const [isModifiedEvent, setModifiedEvent] = useState(false);
  const [allPartners, setAllPartners] = useState([]);
  const [isNewPartner, setIsNewPartner] = useState(false);
  const [name, setName] = useState({ text: '', valid: null });
  const now = new Date();

  const DateCell = ({
    range,
    value,
    children
  }) => {
    now.setHours(0, 0, 0, 0);

    return (
      <>
        {value < now ? (
          <div style={{
            width: "14.3%",
            background: "#C9C9C9",
            border: "solid 1px #fff"
          }}>
            {children}
          </div>
        ) : (
          <>
            <div style={{
              width: "14.3%",
              border: "solid 1px #fff"
            }}>
              {children}
            </div>
          </>
        )}
      </>
    )
  }

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const handleStartTimeChange = (event) => {
    setStartTime(event.target.value);

    if (openEvent) {
      validateModifiedButton(event.target.value, true);
    }
  };

  const handleEndTimeChange = (event) => {
    setEndTime(event.target.value);

    if (openEvent) {
      validateModifiedButton(event.target.value, false);
    }
  };

  const onChangeDatePicker = (e) => {
    var date = e.target.value;
    var year = date.substring(0, 4);
    var month = date.substring(5, 7);
    var day = date.substring(8);

    setNewEventDate(year + "-" + (month - 1) + "-" + day);
    validateModifiedButton('', false);
  }

  const handleEventSelected = (event) => {
    setOpenEvent(true);
    getEventSelected(event);
  };

  const onChange = (e) => {
    setName({ ...name, text: e.target.value });
  }
  const validateField = () => {
    if (expressions.textNumberAndSymbols.test(name.text) && name.text != '') {
      setName({ ...name, valid: 'true' });
    } else {
      setName({ ...name, valid: 'false' });
    }
  }

  function getParsedMonth(month) {
    var value = "01";

    switch (month) {
      case 'Jan':
        value = "01";
        break;
      case 'Feb':
        value = "02";
        break;
      case 'Mar':
        value = "03";
        break;
      case 'Apr':
        value = "04";
        break;
      case 'May':
        value = "05";
        break;
      case 'Jun':
        value = "06";
        break;
      case 'Jul':
        value = "07";
        break;
      case 'Aug':
        value = "08";
        break;
      case 'Sep':
        value = "09";
        break;
      case 'Oct':
        value = "10";
        break;
      case 'Nov':
        value = "11";
        break;
      case 'Dec':
        value = "12";
        break;
      default:
        value = "01";
    }
    return value;
  }

  function getParsedDate(date) {
    date = String(date).split(' ');
    var days = String(date[0]).split('-');
    var hours = String(date[1]).split(':');
    return [parseInt(days[0]), parseInt(days[1]) - 1, parseInt(days[2]), parseInt(hours[0]), parseInt(hours[1]), parseInt(hours[2])];
  }

  function getEventSelected(event) {
    allSaunaSchedule.map((item) => {
      var startString = event.start.toString();
      var endString = event.end.toString();
      var startTime = startString.substring(11, 15) + "-" + parseFloat(getParsedMonth(startString.substring(4, 7)) - 1).toString() + "-" + startString.substring(8, 10) + " " + startString.substring(16, 21);
      var endTime = endString.substring(11, 15) + "-" + parseFloat(getParsedMonth(endString.substring(4, 7)) - 1).toString() + "-" + endString.substring(8, 10) + " " + endString.substring(16, 21);

      if (startTime.length > 15) {
        if (item.userName == event.title && item.startTime == startTime && item.endTime == endTime) {
          setStartTime(item.startTime.substring(11));
          setEndTime(item.endTime.substring(11));
          setEventModified({
            id: item.id, userId: item.userId, title: item.userName, startDate: item.startTime.substring(0, 10), start: item.startTime.substring(11),
            endDate: item.endTime.substring(0, 10), end: item.endTime.substring(11), gender: item.saunaGenderType, isPartnerOfGym: item.isPartnerOfGym
          });
        }
      } else {
        if (item.userName == event.title && item.startTime == startTime && item.endTime == endTime) {
          setStartTime(item.startTime.substring(10));
          setEndTime(item.endTime.substring(10));
          setEventModified({
            id: item.id, userId: item.userId, title: item.userName, startDate: item.startTime.substring(0, 9), start: item.startTime.substring(10),
            endDate: item.endTime.substring(0, 9), end: item.endTime.substring(10), gender: item.saunaGenderType, isPartnerOfGym: item.isPartnerOfGym
          });
        }
      }
    });
  }

  function validateModifiedButton(value, isStartTime) {
    if (newEventDate != '') {
      setModifiedEvent(true);
    }
    if (isStartTime && value != eventModified.start) {
      setModifiedEvent(true);
    } else {
      if (!isStartTime && value != eventModified.end) {
        setModifiedEvent(true);
      } else {
        setModifiedEvent(false);
      }
    }
  }

  const onSelectSlot = ({ action, slots }) => {
    var month = getParsedMonth(slots.toString().substring(4, 7));
    var day = slots.toString().substring(8, 10);
    var year = slots.toString().substring(11, 15);
    var hour = slots.toString().substring(16, 24);
    var date = new Date(...getParsedDate(year + "-" + month + "-" + day + " " + hour));

    if (action === "click" && date >= now) {
      setOpenSlot(true);
      setDateSlot(slots.toString().substring(4, 15));
    }

    return false;
  };

  const onTagsChange = (event, values) => {
    if (values != null) {
      localStorage.setItem('SaunaName', values.name + " " + values.lastName);
      localStorage.setItem('SaunaGender', values.gender);
      localStorage.setItem('SaunaId', values.id);
      setPartner({
        name: values.name + " " + values.lastName, id: values.id,
        gender: values.gender, valid: 'true', isPartnerOfGym: values.isPartnerOfGym
      });
    } else {
      localStorage.setItem('SaunaName', "");
      localStorage.setItem('SaunaGender', "");
      localStorage.setItem('SaunaId', "");
      setPartner({ name: '', id: '', gender: '', valid: 'false', isPartnerOfGym: 0 });
    }
  }

  const saunaSelected = (index) => (event) => {
    if (index == 1) {
      setIsSelectedWomen(true);
      setIsSelectedMen(false);
    } else {
      setIsSelectedWomen(false);
      setIsSelectedMen(true);
    }
  };

  const onAddSaunaDate = async e => {
    e.preventDefault();

    if (!isNewPartner) {
      if (name.valid === 'true') {

        const newPartnerSauna = {
          name: name.text, gender: isSelectedWomen ? "Mujer" : "Hombre"
        };

        const response = await fetch(baseUrl + "createPartnerSauna", {
          method: 'POST',
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
          body: JSON.stringify(newPartnerSauna)
        });

        const json = await response.json();

        if (json.message == "Ok") {
          localStorage.setItem("idSuna", json.content);
          const saunaSchedule = {
            userId: localStorage.getItem("idSuna"), userName: name.text, startTime: dateSlot + " " + startTime,
            endTime: dateSlot + " " + endTime, saunaGenderType: isSelectedWomen ? "Mujer" : "Hombre",
            isPartnerOfGym: 0
          };

          const response = await fetch(baseUrl + "createSaunaSchedule", {
            method: 'POST',
            headers: {
              'Accept': 'application/json', 'Content-Type': 'application/json',
              'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(saunaSchedule)
          });

          const jsonSauna = await response.json();
          if (jsonSauna.message == "Ok") {
            setPartner({ name: '', gender: '', id: '', valid: null, isPartnerOfGym: 0 });
            setStartTime('00:00');
            setEndTime('00:00');
            setIsNewPartner(false);
            setName({ text: '', valid: null });
          } else {
            if (jsonSauna.message == "Access is denied") {
              setShowModal(true);
            }
          }
        } else {
          if (json.message == "Access is denied") {
            setShowModal(true);
          }
        }
      }
    } else {
      if (partner.valid === 'true') {
        var gender = "";

        if (partner.gender != "Hombre" || partner.gender != "Mujer") {
          gender = partner.gender;
        }

        const saunaSchedule = {
          userId: partner.id, userName: partner.name, startTime: dateSlot + " " + startTime,
          endTime: dateSlot + " " + endTime, saunaGenderType: gender != "" ? gender : isSelectedWomen ? "Mujer" : "Hombre",
          isPartnerOfGym: partner.isPartnerOfGym
        };

        const response = await fetch(baseUrl + "createSaunaSchedule", {
          method: 'POST',
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
          body: JSON.stringify(saunaSchedule)
        });

        const json = await response.json();
        if (json.message == "Ok") {
          setPartner({ name: '', gender: '', id: '', valid: null, isPartnerOfGym: 0 });
          setStartTime('00:00');
          setEndTime('00:00');
        } else {
          if (json.message == "Access is denied") {
            setShowModal(true);
          }
        }
      }
    }

    localStorage.setItem('SaunaGender', "");
    localStorage.setItem('SaunaId', "");
    localStorage.setItem('idSauna', "");
    setCalendarKey(calendarKey + 1);
    setOpenSlot(false);
    fetchSaunaSchedule();
  };

  const onDeleteSaunaDate = async e => {
    e.preventDefault();

    const response = await fetch(baseUrl + "deleteSaunaSchedule/" + eventModified.id, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      }
    });

    const json = await response.json();
    if (json.message == "Ok") {
      setEventModified({ id: '', userId: '', title: '', startDate: '', start: '', endDate: '', end: '', gender: '', isPartnerOfGym: 0 });
      setStartTime('00:00');
      setEndTime('00:00');
    } else {
      if (json.message == "Access is denied") {
        setShowModal(true);
      }
    }

    setCalendarKey(calendarKey + 1);
    setOpenEvent(false);
    fetchSaunaSchedule();
  };

  const onUpdateSaunaDate = async e => {
    e.preventDefault();

    const saunaSchedule = {
      id: eventModified.id, userId: eventModified.userId, userName: eventModified.title, startTime: newEventDate != "" ? newEventDate + " " + startTime :
        eventModified.startDate + " " + startTime, endTime: newEventDate != "" ? newEventDate + " " + endTime : eventModified.endDate + " " + endTime,
      saunaGenderType: eventModified.gender
    };

    const response = await fetch(baseUrl + "updateSaunaSchedule/" + eventModified.id, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json', 'Content-Type': 'application/json',
        'Authorization': localStorage.getItem("token")
      },
      body: JSON.stringify(saunaSchedule)
    });

    const json = await response.json();
    if (json.message == "Ok") {
      setEventModified({ id: '', userId: '', title: '', startDate: '', start: '', endDate: '', end: '', gender: '', isPartnerOfGym: 0 });
      setStartTime('00:00');
      setEndTime('00:00');
      setNewEventDate('');
      setModifiedEvent(false);
    } else {
      if (json.message == "Access is denied") {
        setShowModal(true);
      }
    }

    setCalendarKey(calendarKey + 1);
    setOpenEvent(false);
    fetchSaunaSchedule();
  };

  const fetchSaunaSchedule = async () => {
    fetch(baseUrl + "saunaSchedule",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data != null && data.error == null) {
          setEvents([]);
          setAllSaunaSchedule(data);
          
          data.map((item) => {
            if (item.startTime.length > 15) {
              var yearStart = item.startTime.substring(0, 4);
              var monthStart = item.startTime.substring(5, 7);
              var dayStart = item.startTime.substring(8, 10);
              var hourStart = item.startTime.substring(11, 13);
              var minuteStart = item.startTime.substring(14);
              var yearEnd = item.endTime.substring(0, 4);
              var monthEnd = item.endTime.substring(5, 7);
              var dayEnd = item.endTime.substring(8, 10);
              var hourEnd = item.endTime.substring(11, 13);
              var minuteEnd = item.endTime.substring(14);

              setEvents(events => ([
                ...events,
                {
                  title: item.userName,
                  start: new Date(parseFloat(yearStart), parseFloat(monthStart), parseFloat(dayStart),
                    parseFloat(hourStart), parseFloat(minuteStart), 0, 0),
                  end: new Date(parseFloat(yearEnd), parseFloat(monthEnd), parseFloat(dayEnd),
                    parseFloat(hourEnd), parseFloat(minuteEnd), 0, 0),
                  resource: item.saunaGenderType
                }
              ]));
            } else {
              var yearStart = item.startTime.substring(0, 4);
              var monthStart = item.startTime.substring(5, 6);
              var dayStart = item.startTime.substring(7, 9);
              var hourStart = item.startTime.substring(10, 12);
              var minuteStart = item.startTime.substring(13);
              var yearEnd = item.endTime.substring(0, 4);
              var monthEnd = item.endTime.substring(5, 6);
              var dayEnd = item.endTime.substring(7, 9);
              var hourEnd = item.endTime.substring(10, 12);
              var minuteEnd = item.endTime.substring(13);

              setEvents(events => ([
                ...events,
                {
                  title: item.userName,
                  start: new Date(parseFloat(yearStart), parseFloat(monthStart), parseFloat(dayStart),
                    parseFloat(hourStart), parseFloat(minuteStart), 0, 0),
                  end: new Date(parseFloat(yearEnd), parseFloat(monthEnd), parseFloat(dayEnd),
                    parseFloat(hourEnd), parseFloat(minuteEnd), 0, 0),
                  resource: item.saunaGenderType
                }
              ]));
            }
          });
        } else {
          setShowModal(true);
        }
      }).catch(error => null);

    setCalendarKey(calendarKey + 1);
    setIsLoading(false);
  }

  const fetchPartners = async () => {
    fetch(baseUrl + "searchPartnerToSauna",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        if (data != null) {
          setAllPartners(data);
        } else {
          setShowModal(true);
        }
      }).catch(error => null);
  }

  useEffect(() => {
    fetchSaunaSchedule();
    fetchPartners();
  }, []);

  function eventStyleGetter(event, start, end, isSelected) {
    var style = {
      backgroundColor: event.resource == "Mujer" ? "#D3379A" : "#377ED3",
      borderRadius: '0px',
      color: '#FFFFFF',
      display: 'block'
    };
    return {
      style: style
    };
  }

  return (
    <>
      <div>
        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}
        {isLoading ? (
          <CircularProgress size={26} className={classes.loginLoader} />
        ) : (
          <>
            <div>
              <div className={classes.divAddPage}>
                <Calendar
                  key={calendarKey}
                  localizer={localizer2}
                  events={events}
                  views={["month", "week", "day", "agenda"]}
                  defaultView="month"
                  defaultDate={new Date()}
                  selectable
                  startAccessor="start"
                  endAccessor="end"
                  style={{
                    height: 500, margin: "10px"
                  }}
                  onSelectEvent={handleEventSelected}
                  onSelectSlot={onSelectSlot}
                  components={{
                    dateCellWrapper: DateCell,
                  }}
                  eventPropGetter={eventStyleGetter}
                  formats={formats}
                  messages={{
                    next: ">",
                    previous: "<",
                    today: "Hoy",
                    month: "Mes",
                    week: "Semana",
                    day: "Día",
                  }}
                />

                <Dialog
                  open={openSlot}
                >
                  <DialogTitle>Agregar reservación</DialogTitle>
                  <DialogContent>
                    <div>
                      <Switch
                        value={isNewPartner}
                        setValue={setIsNewPartner}
                        label="Socio registrado"
                      />

                      {!isNewPartner ? (
                        <>
                          <label className={classes.label} >Socio</label>

                          <TextField
                            value={name.text}
                            onChange={onChange}
                            placeholder={"Nombre"}
                            type={"text"}
                            name={"name"}
                            onKeyUp={validateField}
                            onBlur={validateField}
                            style={{ width: '85%' }}
                            inputStyle={{ width: '85%' }}
                          />
                        </>
                      ) : (
                        <>
                          <label className={classes.label} >Socio</label>
                          <Autocomplete
                            options={allPartners}
                            getOptionLabel={option => option.name + " " + option.lastName}
                            onChange={onTagsChange}
                            openText={"Abrir"}
                            closeText={"Cerrar"}
                            clearText={"Limpiar"}
                            noOptionsText={"Sin resultados"}
                            renderInput={params => (
                              <TextField
                                {...params}
                                value={partner.name}
                                variant="standard"
                                placeholder={"Nombre"}
                                fullWidth
                              />
                            )}
                          />
                        </>
                      )}

                    </div>
                    <br />
                    <div className={classes.row}>
                      <div>
                        <label className={classes.label} >Hora de entrada</label>
                        <TextField
                          id="time"
                          type="time"
                          defaultValue="00:00"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={startTime}
                          onChange={handleStartTimeChange}
                        />
                      </div>

                      <div>
                        <label className={classes.label} >Hora de salida</label>
                        <TextField
                          id="time"
                          type="time"
                          defaultValue="00:00"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={endTime}
                          onChange={handleEndTimeChange}
                        />
                      </div>
                    </div>

                    {(localStorage.getItem('SaunaGender') == "Hombre") ? (
                      <></>
                    ) : (
                      <>
                        {(localStorage.getItem('SaunaGender') == "Mujer") ? (
                          <></>
                        ) : (
                          <>
                            <label className={classes.label} >Sauna</label>

                            <div className={classes.rowButtons}>
                              <button
                                className={isSelectedWomen ? classes.selectedButtonSauna : classes.enableButtonSauna}
                                onClick={saunaSelected(1)}
                              >Mujer</button>

                              <button
                                className={isSelectedMen ? classes.selectedButtonSauna : classes.enableButtonSauna}
                                onClick={saunaSelected(2)}
                              >Hombre</button>

                            </div>
                            <br /><br /><br />
                          </>
                        )}
                      </>
                    )}
                    <br />

                    <div className={classes.rowButtons}>
                      <button
                        className={isLoading ? classes.cancelButtonDisable : classes.cancelButton}
                        onClick={(e) => {
                          setOpenSlot(false); setIsLoading(false); setIsSelectedWomen(false);
                          setIsSelectedMen(false); localStorage.setItem('SaunaName', "");
                          localStorage.setItem('SaunaGender', ""); localStorage.setItem('SaunaId', "");
                        }}
                        disabled={isLoading}
                      >Cancelar</button>

                      {isNewPartner ? (
                        <>
                          <button
                            className={!isLoading && partner.valid == "true" ? classes.addButton : classes.addButtonDisable}
                            onClick={onAddSaunaDate}
                            disabled={isLoading || partner.valid == "true" ? false : true}
                          >Aceptar</button>
                        </>
                      ) : (
                        <>
                          <button
                            className={!isLoading && name.valid == "true" ? classes.addButton : classes.addButtonDisable}
                            onClick={onAddSaunaDate}
                            disabled={isLoading || name.valid == "true" ? false : true}
                          >Aceptar</button>
                        </>
                      )}
                    </div>
                  </DialogContent>
                </Dialog>

                <Dialog
                  open={openEvent}
                >
                  <DialogTitle>Reservación</DialogTitle>
                  <DialogContent>
                    <div>
                      <label className={classes.label} >Socio</label>
                      <label className={classes.label} >{eventModified.title}</label>
                    </div>
                    <br />

                    <TextField
                      id="date"
                      type="date"
                      defaultValue={eventModified.startDate}
                      className={classes.inputForm}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={onChangeDatePicker}
                      style={{ width: '85%' }}
                      inputStyle={{ width: '85%' }}
                    />
                    <br /><br />

                    <div className={classes.row}>
                      <div>
                        <label className={classes.label} >Hora de entrada</label>
                        <TextField
                          id="time"
                          type="time"
                          defaultValue="00:00"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={startTime}
                          onChange={handleStartTimeChange}
                        />
                      </div>

                      <div>
                        <label className={classes.label} >Hora de salida</label>
                        <TextField
                          id="time"
                          type="time"
                          defaultValue="00:00"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          value={endTime}
                          onChange={handleEndTimeChange}
                        />
                      </div>
                    </div>
                    <br />

                    <div className={classes.rowButtons}>
                      <button
                        className={isLoading ? classes.cancelButtonDisable : classes.cancelButton}
                        onClick={(e) => {
                          setOpenEvent(false); setIsLoading(false); setIsSelectedWomen(false);
                          setIsSelectedMen(false); localStorage.setItem('SaunaName', "");
                          localStorage.setItem('SaunaGender', ""); localStorage.setItem('SaunaId', ""); setModifiedEvent(false);
                        }}
                        disabled={isLoading}
                      >Cancelar</button>

                      <button
                        className={classes.cancelButton}
                        onClick={onDeleteSaunaDate}
                        disabled={!isLoading ? false : true}
                      >Eliminar</button>

                      <button
                        className={!isLoading && isModifiedEvent ? classes.addButton : classes.addButtonDisable}
                        onClick={onUpdateSaunaDate}
                        disabled={isLoading || isModifiedEvent ? false : true}
                      >Modificar</button>
                    </div>
                  </DialogContent>
                </Dialog>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
}
